(() => {
  const root = document.querySelector('[data-mc-product]');
  if (!root) return;
  // Keep the original required line-item radios and their form ownership.
  const groups = [...root.querySelectorAll('.mc-bundle-colors__group')];
  const bundle = root.querySelector('[data-mc-bundle-colors]');
  if (bundle && groups.length) {
    bundle.classList.add('mc-compact-bundle');
    const heading = document.createElement('p'); heading.className = 'mc-compact-bundle__title';
    heading.textContent = `Sélectionner ${groups.length} couleurs`; bundle.prepend(heading);
    root.querySelector('.mc-variant-tiles')?.after(bundle);
    root.classList.add('mc-has-color-bundle');
  }
  groups.forEach((group, index) => {
    const legend = group.querySelector('legend');
    const choices = group.querySelector('.mc-bundle-colors__choices');
    if (!choices) return;
    const disclosure = document.createElement('details');
    disclosure.className = 'mc-color-step';
    const summary = document.createElement('summary');
    const title = legend?.textContent || `Couleur ${index + 1}`;
    const update = () => {
      const checked = group.querySelector('input:checked');
      summary.replaceChildren();
      const image = checked?.closest('label')?.querySelector('img');
      if (image) { const clone = image.cloneNode(); clone.alt = ''; summary.append(clone); }
      const text = document.createElement('span');
      text.textContent = checked ? checked.value : String(index + 1);
      text.className = checked ? 'mc-visually-hidden' : '';
      summary.setAttribute('aria-label', `${title} · ${checked?.value || 'Choisir'}`);
      summary.title = summary.getAttribute('aria-label');
      summary.append(text);
    };
    disclosure.append(summary, choices); group.append(disclosure);
    if (legend) legend.classList.add('mc-visually-hidden');
    update();
    group.addEventListener('change', () => { update(); disclosure.open = false; });
    group.addEventListener('invalid', () => { disclosure.open = true; }, true);
  });
  // Present kit options separately, resolving the exact native variant.
  const select = root.querySelector('[data-variant-select]');
  if (select && !groups.length && /kit/.test(location.pathname)) {
    const names = JSON.parse(root.dataset.nativeOptions || '[]');
    const variants = [...select.options].map(option => ({option, values: JSON.parse(option.dataset.options || '[]')}));
    if (names.length > 1) {
      const steps = document.createElement('div'); steps.className = 'mc-kit-steps';
      const controls = [];
      names.forEach((name,index) => {
        const label = document.createElement('label');
        const title = document.createElement('span'); title.textContent = `${index + 1}. ${name}`;
        const control = document.createElement('select'); control.setAttribute('aria-label',name);
        [...new Set(variants.map(v => v.values[index]))].forEach(value => { const option = document.createElement('option'); option.value=value; option.textContent=value; control.append(option); });
        label.append(title,control); steps.append(label); controls.push(control);
      });
      const sync = () => { const current=variants.find(v=>v.option.value===select.value); controls.forEach((c,i)=>{c.value=current.values[i];}); };
      controls.forEach(control=>control.addEventListener('change',()=>{
        const match=variants.find(v=>v.values.every((value,i)=>value===controls[i].value));
        if(match){select.value=match.option.value;select.dispatchEvent(new Event('change',{bubbles:true}));}else sync();
      }));
      select.before(steps); select.classList.add('mc-visually-hidden');
      root.querySelector('.mc-variant-tiles')?.setAttribute('hidden','');
      root.querySelector('.mc-option-label')?.setAttribute('hidden','');
      select.addEventListener('change',sync); sync();
    }
  }
  const faq = [...root.querySelectorAll('.mc-source-accordions details')].map(item=>{
    const clone=item.cloneNode(true); const summary=clone.querySelector('summary');
    const name=summary?.textContent.trim(); summary?.remove();
    return name && clone.textContent.trim() ? {'@type':'Question',name,acceptedAnswer:{'@type':'Answer',text:clone.textContent.trim()}} : null;
  }).filter(Boolean);
  if(faq.length){const script=document.createElement('script');script.type='application/ld+json';script.textContent=JSON.stringify({'@context':'https://schema.org','@type':'FAQPage',mainEntity:faq});document.head.append(script);}
})();
